import { FullpageErrorDisplay } from "@/components/FullpageErrorDisplay";
import { useTranslation } from "react-i18next";
import { BrandingContext } from "./BrandingContext";
import { BrandingLoadingFallback } from "./BrandingLoadingFallback";
import { useBrandingQuery } from "./useBrandingQuery";

export function BrandingContextProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { data: branding, isPending, isError, error } = useBrandingQuery();
  const { t } = useTranslation();

  if (isPending) {
    return <BrandingLoadingFallback />;
  }

  if (isError) {
    return (
      <FullpageErrorDisplay title={t("branding.error_loading")} error={error} />
    );
  }

  return <BrandingContext value={branding}>{children}</BrandingContext>;
}
